import { ConfigModuleName, CoreConfigModuleName } from "@/store/modules/types/configModuleTypes";

const getDefaultState = () => {
    return {
        maxIdle: 20 * 60 * 1000, // 20 minuter
        countdownTime: 30 * 1000, // 30 sekunder
        enableIdle: true,
        lastActive: new Date(),
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        reset(state) {
            Object.assign(state, getDefaultState());
        },
        /**
         * Millisekunder som användaren får vara idle (+ countdown) innan de blir utloggade
         * @param state
         * @param {number} maxIdle
         */
        setMaxIdle(state, maxIdle) {
            state.maxIdle = maxIdle;
        },
        setCountdownTime(state, countdownTime) {
            state.countdownTime = countdownTime;
        },
        setEnableIdle(state, enableIdle) {
            state.enableIdle = enableIdle;
        },
        setLastActive(state, lastActive) {
            state.lastActive = lastActive;
        },
    },
    getters: {
        /**
         * @param state
         * @returns {number} Millisekunder som användaren får vara idle (+ countdown) innan de blir utloggade
         */
        maxIdle(state) {
            return state.maxIdle;
        },
        enableIdle(state) {
            return state.enableIdle;
        },
        /**
         * @param state
         * @returns {number} Millisekunder som representerar antal sekunder fönstret med varning om utloggning ska visas
         */
        countdownTime(state) {
            return state.countdownTime;
        },
        lastActive(state) {
            return state.lastActive;
        },
    },
    actions: {
        configure({ dispatch }) {
            dispatch("setMaxIdle");
            dispatch("setCountdownTime");
        },
        setMaxIdle({ commit, rootGetters }, maxIdle) {
            const defaultMaxIdleMinutes = rootGetters["config/configByName"]({
                moduleName: ConfigModuleName.Core,
                subModuleName: CoreConfigModuleName.MaxIdleMinutes,
            });
            commit("setMaxIdle", maxIdle ? maxIdle : defaultMaxIdleMinutes * 60 * 1000);
        },
        setCountdownTime({ commit, rootGetters }, countdownTime) {
            const defaultCountdownTimeSeconds = rootGetters["config/configByName"]({
                moduleName: ConfigModuleName.Core,
                subModuleName: CoreConfigModuleName.IdleCountdownTimeSeconds,
            });
            commit("setCountdownTime", countdownTime ? countdownTime : defaultCountdownTimeSeconds * 1000);
        },
    },
};
